import type { BillingAccountExtended, Role } from '@ctct/domain-layer';

import type { TranslationGetter, TranslationPaths } from '../../../types';

export class UserPermissionsService {
  private readonly PARTNERS_AND_ROLES_LINK =
    'https://knowledgebase.constantcontact.com/email-digital-marketing/articles/KnowledgeBase/44425-Partners-Adding-additional-user-roles?lang=en_US';

  constructor(
    private extendedBillingAccountQuery: BillingAccountExtended,
    private userRole: Role,
    private t: TranslationGetter
  ) {}

  public api() {
    return {};
  }

  public data() {
    return {
      shouldDisplayBanner: () =>
        this.extendedBillingAccountQuery.shouldBlockBilling() || !this.userRole.canBuyProducts(),
      getBannerContent: () => {
        return {
          title: this.t('application-layer.user-permissions-banner.title'),
          textKey: 'application-layer.user-permissions-banner.text' as TranslationPaths,
          partnersAndRolesLink: this.PARTNERS_AND_ROLES_LINK,
        };
      },
    };
  }

  public handlers() {
    return {};
  }
}
